module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('v-header', {
    attrs: {
      "name": _vm.name,
      "isDashboard": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "item1"
  }, [_c('v-item2')], 1), _vm._v(" "), _c('div', {
    staticClass: "item2"
  }, [_c('v-item5')], 1), _vm._v(" "), _c('img', {
    staticClass: "lf",
    attrs: {
      "src": require("../../../assets/img/chaye/lf.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item3"
  }, [_c('v-table')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('v-center', {
    attrs: {
      "outputValue": _vm.outputValue,
      "productionScale": _vm.productionScale
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "item4"
  }, [_c('v-item1')], 1), _vm._v(" "), _c('div', {
    staticClass: "item5"
  }, [_c('v-item3')], 1), _vm._v(" "), _c('img', {
    staticClass: "rl",
    attrs: {
      "src": require("../../../assets/img/chaye/rl.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item6"
  }, [_c('v-table2')], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-549323d3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/chaye/index.vue
// module id = 2001
// module chunks = 2